import { useEffect } from "react";

/**
 * Updates document title + OG/Twitter meta tags depending on current site.
 * Pass `site = "studio" | "sgb"`.
 */
export const useDocumentMeta = (site = "studio") => {
  useEffect(() => {
    const map = {
      studio: {
        title: "patrice.studio · Patrice Schreiter",
        desc: "Ein digitales Atelier für Sichtbarkeit, Storytelling und alles, was zwischen Substanz und Ästhetik liegt.",
        image: "/og-patrice.jpg",
      },
      sgb: {
        title: "Sichtbar Gut Bewertet — Deine digitale Wirkung. Klar sichtbar.",
        desc: "Bewertungsmanagement, CLEAR SIGNAL™ Profilanalysen, Webseiten und Unterstützung bei Account-Sperrungen.",
        image: "/og-sgb.jpg",
      },
    };
    const m = map[site] || map.studio;
    if (typeof document === "undefined") return;
    document.title = m.title;
    const set = (id, attr, val) => {
      const el = document.getElementById(id);
      if (el) el.setAttribute(attr === "name" ? "content" : "content", val);
    };
    set("og-title", "content", m.title);
    set("og-desc", "content", m.desc);
    set("og-image", "content", m.image);
    set("tw-title", "content", m.title);
    set("tw-desc", "content", m.desc);
    set("tw-image", "content", m.image);
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", m.desc);
  }, [site]);
};
